module.exports = __webpack_public_path__ + "img/star.9b7cb417.svg";